import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=67390558&scoped=true&"
import script from "@/scripts/Message/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Message/index.js?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=67390558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67390558",
  null
  
)

export default component.exports